<template>
  <div
    :class="{
      'nvr-box': true,
      'nvr-box-large': scale < 1.6 ? true : false,
      'nvr-box-tiny': scale >= 1.6 ? true : false,
    }"
    :style="{ width: width, background: backgroundColor }"
  >
    <div class="nvr-player">
      <div class="player_title"></div>
      <div id="divPlugin" class="plugin" :style="{ height: isScale ? '500px' : height }">
        <video
          v-if="isVideo"
          id="myPlayer"
          ref="myPlayer"
          class="centeredVideo"
          controls
          muted
          autoplay
          width="1024"
          height="776"
        >Your browser is too old which doesn't support HTML5 video.</video>
        <video
          v-if="!isVideo && isAll && isSence1"
          id="recoderVideo"
          class="centeredVideo"
          x5-playsinline="true"
          playsinline="true"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          x5-video-orentation="portraint"
          preload="auto"
          muted
          width="1024"
          height="740"
        ></video>
        <video
          v-if="!isVideo && isAll && !isSence1"
          id="recoderVideoOther2"
          class="centeredVideo"
          x5-playsinline="true"
          playsinline="true"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          x5-video-orentation="portraint"
          preload="auto"
          muted
          width="1024"
          height="740"
        ></video>
        <video
          v-else-if="!isVideo && !isAll"
          id="recoderVideoOther"
          class="centeredVideo"
          x5-playsinline="true"
          playsinline="true"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          x5-video-orentation="portraint"
          preload="auto"
          muted
          width="1024"
          height="740"
        ></video>
      </div>
      <div v-if="!isVideo" class="recoder-bar" :style="{ left: left }">
        <div class="recoders" v-for="(item, i) in recoderList" :key="i"></div>
        <div ref="sliderBar" class="block" style="width: 100%">
          <el-slider
            @change="recordChange(curRecodeTime, true)"
            v-model="curRecodeTime"
            :max="1440"
            :step="1"
            :format-tooltip="formatTooltip"
          ></el-slider>
        </div>
      </div>
      <div v-if="!isVideo" class="hour-bar" :style="{ left: left }">
        <div class="hour-item" v-for="(item, n) in hourList" v-bind:key="'hour-' + n">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import flvjs from 'flv-h265.js'
import axios from 'axios'
import { unref } from 'vue'
const url = '/api/v1/login?username=easycvr&password=5cdecdb8e87a0db1fe6e35555a870ae5'
export default {
  name: 'VdmCvr',
  //props: ["recodeDate", "nvrIp", "channelId", "lastTime", "isScale", "isAll", 'width', 'height', "left"],
  props: {
    videoInfo: {
      type: Object,
      default: () => ({})
    },
    isScale: {
      type: Boolean,
      default: false
    },
    isAll: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    left: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    }
  },
  inject: ['getVideoClose', 'updateVideoType'],
  computed: {
    ...mapState({ dialog: state => state.dialog }),
    ...mapState({ app: state => state.app }),
    ...mapGetters(['dialogVisible'])
  },
  watch: {
    videoInfo: {
      handler(n) {
        const { szIp, iChannelId, recodeDate, type } = n;
        this.cameraType = type;
        if(type === '全景1') {
          this.isSence1 = true;
        } else {
          this.isSence1 = false;
        }
        this.nvrIp = szIp;
        this.channelId = iChannelId;
        if (recodeDate) {
          this.playBackTime = recodeDate
        } else {
          let nowObj = new Date().getTime()
          let nowDate = moment(nowObj).format('YYYY-MM-DD')
          let dailyObj = nowDate + ' 00:00:00'
          this.playBackTime = dailyObj
        }
        this.finishTimeEdit()
        console.log(this.nvrIp, 'ip')
        console.log(this.channelId, '通道号')
        console.log(this.playBackTime, '回放时间')
        this.getEasyCvrList(szIp, iChannelId)
      },
      deep: true
    }
  },
  data() {
    return {
      isSence1: true,
      customerId: this.$store.state.customerId,
      videoBaseUrl: bmeConfig.easyNvrUrl, //工厂本地地址
      easyNvrProtocol: bmeConfig.easyNvrProtocol,
      curVideoName: "",
      recordeId: "",
      nvrIp: "",
      channelId: "",
      playBackTime: "",
      deviceId: "",
      cameraType: "", // 相机类型
      token: window.easyAxiosToken, // 摄像头token
      scale: 1,
      iChannelId: 1,
      curRecodeTime: 0,
      isVideo: false,
      recoderVideo: null,
      recorderTimer: null,
      reloadTimer: null,
      keepRecoderAliveTimer: null,
      hls: null,
      recoderList: [],
      hourList: [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00'
      ],
      channelsObj: {},
      channelsIds: {},
      channelItems: [],
      selTimeStamp: '',
      curHour: 0,
      curMinute: 0,
      curSecond: 0,
      reloadTimer1: null, // vdm
      reloadTimer2: null, // 全景1
      reloadTimer3: null, // 全景2
    }
  },
  methods: {
    ...mapActions(['setDialog']),
    date_change(replayTime) {
      let that = this
      let ts = new Date().getTime()
      let curDailyObj = new Date(replayTime ? replayTime : this.recodeDate)
      console.log(moment(curDailyObj).format('YYYY-MM-DD HH:mm:ss'), 'curDailyObj')
      let curDaily =
        curDailyObj.getFullYear() + that.convertDoubleNum(curDailyObj.getMonth() + 1) + that.convertDoubleNum(curDailyObj.getDate())
      let getUrl =
        '/api/v1/record/querydaily?id=' +
        that.recordeId +
        '&recordType=Device' +
        '&period=' +
        curDaily +
        '&_=' +
        ts +
        '&token=' +
        window.easyAxiosToken
      $.ajax({
        url: getUrl,
        success(res) {
          that.recoderList = []
          let tmpList = res.list
          tmpList.forEach(item => {
            let stStr =
              item.startAt.substr(0, 4) +
              '/' +
              item.startAt.substr(4, 2) +
              '/' +
              item.startAt.substr(6, 2) +
              ' ' +
              item.startAt.substr(8, 2) +
              ':' +
              item.startAt.substr(10, 2) +
              ':' +
              item.startAt.substr(12, 2)
            let strB = item.startAt.substr(0, 4) + '/' + item.startAt.substr(4, 2) + '/' + item.startAt.substr(6, 2) + ' 00:00:00'
            let strE = item.startAt.substr(0, 4) + '/' + item.startAt.substr(4, 2) + '/' + item.startAt.substr(6, 2) + ' 23:59:59'
            let st = new Date(stStr).getTime()
            let delta = st - new Date(strB).getTime()
            let delta_ = new Date(strE).getTime() - new Date(strB).getTime()
            let l = Math.floor((delta / delta_) * 1440)
            let w = Math.floor(((item.duration * 1000) / delta_) * 1440) - 2
            that.recoderList.push({
              l: l,
              w: w,
              hls: item.hls,
              b: st,
              s: item.startAt,
              duration: item.duration,
              name: item.name,
              startAt: item.startAt
            })
          })
          that.recordChange(that.curRecodeTime, false)
        }
      })
    },
    // 获取通道视频信息封装videlInfo
    getEasyCvrList(szIP, iChannelId) {
      let that = this
      let ts = new Date().getTime()
      let getUrl = ''
      if (this.customerId === 39) {
        getUrl = '/api/v1/devicesconfig?start=0&limit=9999'
      } else {
        getUrl = bmeConfig.cvrNewApi ? '/api/v1/devicesconfig?start=0&limit=9999' : '/api/v1/devices?start=0&limit=9999'
      }
      axios
        .get(getUrl, {
          params: { token: window.easyAxiosToken }
        })
        .then(res => {
          if (res.data.EasyDarwin.Header.ErrorNum == 200) {
            let devices = res.data.EasyDarwin.Body.Devices
            for (let i = 0; i < devices.length; i++) {
              if (devices[i]['DeviceIp'] == szIP || devices[i]['DeviceName'] == szIP) {
                let tmpDeviceID = devices[i]['DeviceID']
                that.deviceId = tmpDeviceID
                let tmpChannels = devices[i]['channels']
                for (let j = 0; j < tmpChannels.length; j++) {
                  if (tmpChannels[j]['Name'] == iChannelId) {
                    that.recordeId = tmpChannels[j]['ChannelID']
                    let tmpChannelID = tmpChannels[j]['ChannelID']
                    let tmpToken = tmpChannels[j]['Token']
                    this.date_change(this.playBackTime)
                    break
                  }
                }
                break
              }
            }
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getCameraClassify() {
      console.log(this.channelsIds, this.channelsObj, 'channels')
      return new Promise((resolve, reject) => {
        let findVideoMonitoringUrl = CONFIG.requestName + this.$apiOpt.findVideoMonitoring
        this.$apiUtils
          .get(findVideoMonitoringUrl, {
            customerId: this.$store.state.customerId,
            isMore: true
          })
          .then(data => {
            data &&
              data.forEach((x1, i1) => {
                x1.list.forEach((x2, i2) => {
                  if (!x2.nvrIp && bmeConfig.useAddressIP) {
                    x2.nvrIp = x2.ipAddress
                  }
                  if (!x2.channelId && bmeConfig.HKchannelId) {
                    x2.channelId = bmeConfig.HKchannelId
                  }
                })
              })
            if (this.channelsObj) {
              data &&
                data.forEach((x1, i1) => {
                  x1.list.forEach((x2, i2) => {
                    if (x2.cameraType === 'newEasyNvr' || bmeConfig.isEasyNvr || bmeConfig.isEasyCvr) {
                      x2['picUrl'] = this.channelsObj
                        ? this.channelsObj[x2.ipAddress]
                          ? this.videoBaseUrl + this.channelsObj[x2.ipAddress]
                          : this.videoBaseUrl + this.channelsObj[x2.nvrIp + '_' + x2.channelId]
                        : ''
                      x2['recordeId'] = this.channelsIds[x2.nvrIp + '_' + x2.channelId]
                    }
                  })
                })
            }
            resolve(data)
          })
      })
    },
    async renderVideo() {
      let videoList = await this.getCameraClassify()
      console.log(videoList, 'videoList')
      let tmp
      videoList.forEach(item => {
        item.list.forEach(it => {
          if (it.ipAddress === this.nvrIp && it.channelId === this.channelId) {
            this.videoBaseUrl = bmeConfig.easyNvrUrl
            this.easyNvrProtocol = bmeConfig.easyNvrProtocol
            this.iChannelId = it.channelId
            this.szIP = it.nvrIp
            this.username = it.nvrUsername
            this.password = it.nvrPassword
            this.ipAddress = it.ipAddress
          }
        })
      })
      this.channelItems.forEach(channel => {
        channel.forEach(item => {
          console.log(item)
          if (item.deviceIp === this.nvrIp && item.Name == this.channelId) {
            this.recordeId = item.ChannelID
          }
        })
      })

      console.log(this.recordeId, this.nvrIp, 'tmp')
      this.date_change()
    },
    recordChange(curRecodeTime, flag) {
      let that = this
      if (curRecodeTime) this.curRecodeTime = curRecodeTime
      this.record_destroy()
      let curTimeObj = new Date(this.playBackTime)
      let curYear = curTimeObj.getFullYear()
      let curMonth = curTimeObj.getMonth() + 1
      let curDate = curTimeObj.getDate()
      let curHour = curTimeObj.getHours()
      let curMinute = curTimeObj.getMinutes()
      let curSecond = curTimeObj.getSeconds()
      let curTime = new Date(curYear + '/' + curMonth + '/' + curDate + ' 00:00:00').getTime()
      curTime = curTime + parseInt((this.curRecodeTime / 1440) * 24 * 3600 * 1000)
      console.log(moment(curTime).format('YYYY-MM-DD HH:mm:ss'), 'curTimepppp')
      let timeObj = new Date(curTime)

      let selTime =
        timeObj.getFullYear() +
        '' +
        that.convertDoubleNum(timeObj.getMonth() + 1) +
        '' +
        that.convertDoubleNum(timeObj.getDate()) +
        '' +
        that.convertDoubleNum(timeObj.getHours()) +
        '' +
        that.convertDoubleNum(timeObj.getMinutes()) +
        '' +
        that.convertDoubleNum(timeObj.getSeconds())

      let endObj = new Date(
        curYear + "/" + curMonth + "/" + curDate + " " + "23:59:59"
      );

      let endTime =
        endObj.getFullYear() +
        '' +
        that.convertDoubleNum(endObj.getMonth() + 1) +
        '' +
        that.convertDoubleNum(endObj.getDate()) +
        '' +
        that.convertDoubleNum(endObj.getHours()) +
        '' +
        that.convertDoubleNum(endObj.getMinutes()) +
        '' +
        that.convertDoubleNum(endObj.getSeconds())

      let tmpArgs =
        "file=NVR&stime=" +
        selTime +
        "&etime=" +
        endTime +
        "&channel=" +
        that.recordeId +
        "&protocol=flv";
      let getUrl =
        this.videoBaseUrl + "/api/v1/devices/record/playback?" + tmpArgs;

      axios
        .get(getUrl, {
          params: { token: window.easyAxiosToken }
        })
        .then(res => {
          if (res.data.EasyDarwin.Header.ErrorNum == 200) {
            let recorderUrl = res.data.EasyDarwin.Body.URL
            this.initRecode(recorderUrl, tmpArgs, 0)
          }
        })
        .catch(err => console.error(err))
    },
    initRecode(url, args, deltaSec) {
      if (this.reloadTimer) {
        clearTimeout(this.reloadTimer)
      }
      this.recorderUrl = url
      this.$nextTick(() => {
        let recoderVideo = null;
        if(!this.isAll) {
          recoderVideo = document.getElementById("recoderVideoOther"); //
        } else {
          if(this.cameraType === '全景1') {
            recoderVideo = document.getElementById("recoderVideo");
          } else {
            recoderVideo = document.getElementById("recoderVideoOther2");
          }
        }
        if (flvjs.isSupported()) {
          let videoBaseUrl = this.videoBaseUrl
          if (this.easyNvrProtocol === 'WS-FLV') {
            videoBaseUrl = videoBaseUrl.replace(/http:\/\//g, 'ws://')
          }
          this.recoderVideo = flvjs.createPlayer(
            {
              type: 'flv',
              isLive: true,
              url: videoBaseUrl + url,
              hasAudio: false
            },
            {
              enableWorker: false,
              enableStashBuffer: false,
              reuseRedirectedURL: true,
              autoCleanupSourceBuffer: true
            }
          )
          this.recoderVideo.attachMediaElement(recoderVideo)
          this.recoderVideo.load()
          if (deltaSec && deltaSec > 0) {
            this.recoderVideo.onloademetadata = () => {
              console.log(this.recoderVideo.duration)
              this.recoderVideo.currentTime = parseInt(deltaSec / 1000)
            }
          }
          let playPromise
          setTimeout(() => {
            if (this.recoderVideo && this.recoderVideo.play) {
              playPromise = this.recoderVideo.play()
              if (playPromise) {
                playPromise
                  .then(() => {
                    setTimeout(() => {
                      console.log('视频加载成功!')
                    }, 1000)
                  })
                  .catch(e => {
                    console.log('加载失败')
                  })
              }
            } else {
              this.reloadRecorde()
            }
          }, 500)
          this.recoderVideo.on(flvjs.Events.ERROR, (errorInfo, errType, errDetail) => {
            if (errorInfo.code == 404) {
              console.log('流媒体代理服务未找到，请检查')
              this.reloadRecorde()
            }
          })
          if (this.recorderTimer) {
            clearInterval(this.recorderTimer)
          }
          this.recorderTimer = setInterval(() => {
            if (!this.recoderVideo.buffered.length) {
              return
            }
            let end = this.recoderVideo.buffered.end(0)
            let diff = end - this.recoderVideo.currentTime
            if (diff >= 1.5) {
              this.recoderVideo.currentTime = end - 0.1
            }
          }, 3 * 10 * 1000);
          if (this.reloadTimer1) {
            clearTimeout(this.reloadTimer1);
          }
          this.reloadTimer1 = setTimeout(() => {
            this.keepRecoderAlive(url, args);
          }, 10 * 1000);
        }
      })
    },
    keepRecoderAlive(url, args) {
      let getUrl =
        this.videoBaseUrl + "/api/v1/devices/record/playback?" +
        args +
        "&type=keepalive&url=" +
        url;
      axios.get(getUrl, {
        params: { token: this.token },
      });
      if (this.reloadTimer1) {
        clearTimeout(this.reloadTimer1);
      }
      this.reloadTimer1 = setTimeout(() => {
        this.keepRecoderAlive(url, args);
      }, 10 * 1000);
    },
    record_destroy() {
      if (this.recorderTimer) {
        clearInterval(this.recorderTimer)
      }
      if (this.reloadTimer1) {
        clearTimeout(this.reloadTimer1);
      }
      try {
        this.recoderVideo ? this.recoderVideo.pause() : ''
        this.recoderVideo ? this.recoderVideo.unload() : ''
        this.recoderVideo ? this.recoderVideo.detachMediaElement() : ''
        //http://localhost:18000/api/v1/devices/stopchannelstream?stream_type=playback&device=1&channel=1&url=%2Fflv%2Fhls%2Fstream_localhost_33_ch0001_04010000823000000_202195125727_202195131540.flv
        let getUrl = `/api/v1/devices/stopchannelstream?stream_type=playback&device=${this.deviceId}&channel=${this.recordeId}&url=${this.recorderUrl}&token=${this.token}`
        $.ajax({
          url: getUrl,
          success: res => {
            console.log(res, 'res')
          }
        })
      } catch (err) {
        console.error(err)
      }
    },
    convertDoubleNum(val) {
      if (val < 10) {
        return '0' + val
      } else {
        return '' + val
      }
    },
    formatTooltip(val) {
      let curTS = (val / 1440) * 24 * 3600 * 1000
      let hourStr = Math.floor(curTS / (3600 * 1000))
      let minuteStr = Math.floor((curTS % (3600 * 1000)) / (60 * 1000))
      let secondStr = Math.floor((curTS % (60 * 1000)) / 1000)
      return (
        (hourStr < 10 ? '0' + hourStr : hourStr) +
        ':' +
        (minuteStr < 10 ? '0' + minuteStr : minuteStr) +
        ':' +
        (secondStr < 10 ? '0' + secondStr : secondStr)
      )
    },
    reloadRecorde(url, args, deltaSec) {
      if (this.reloadTimer) {
        clearTimeout(this.reloadTimer)
      }
      this.record_destroy()
      this.reloadTimer = setTimeout(() => {
        this.initRecode(url, args, deltaSec)
      }, 500)
    },
    finishTimeEdit() {
      this.timeSelTag = false
      let newObj = new Date(this.playBackTime)
      this.curHour = newObj.getHours()
      this.curMinute = newObj.getMinutes()
      this.curSecond = newObj.getSeconds()
      let curTS = this.curHour * (3600 * 1000)
      curTS += this.curMinute * (60 * 1000)
      curTS += this.curSecond * 1000
      let curRecodeTime = parseInt((curTS / 1000 / 3600 / 24) * 1440)
      this.curRecodeTime = curRecodeTime
    }
  },
  mounted() {},
  unmounted() {
    this.record_destroy()
  }
}
</script>

<style lang="scss">
.recoder-bar {
  width: 1545px;
  position: absolute;
  bottom: -20px;
  left: -95%;
  .block {
    z-index: 99;
    position: absolute;
    left: 0px;
    transform-origin: left top;
  }
  .el-slider__runway {
    background: none !important;
    margin: 0px !important;
  }
  .el-slider__bar {
    background: darkorange !important;
  }
}
</style>
<style lang="scss" scoped="scoped">
.nvr-box {
  position: relative;
  // background-color: #000;
  // background-color: #15244D;
  width: 500px;
  .close-box {
    top: 6px;
    right: 6px;
  }
  .nvr-back-box {
    position: absolute;
    top: 6px;
    right: 135px;
    z-index: 1;
    cursor: pointer;
    &:hover {
      background-image: url('./img/back_active.png');
    }
  }
  .nvr-player {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    position: relative;
    .player_title {
      width: 100%;
      background: #000;
      position: absolute;
      top: 0px;
      left: 0;
      font-size: 26px;
      line-height: 50px;
      padding-left: 10px;
    }
    #divPlugin {
      height: 650px;
      position: relative;
      z-index: 1;
    }
    .player_setting {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 90px;
      background: rgba(0, 0, 0, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 100000;
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
      }
      .player_left {
        display: flex;
        align-items: center;
        .player_left_inner {
          display: flex;
        }
        .icon_play {
          width: 40px;
          height: 40px;
          margin: 0 25px 0 35px;
          background-image: url('./img/icon_pause.png');
          background-size: 100% 100%;
          cursor: pointer;
        }
        .icon_pause {
          background-image: url('./img/icon_play.png');
        }

        .player_time {
          font-size: 25px;
        }
      }
    }
    .player_right {
      display: flex;
      height: 80px;
      .speed_box {
        ul {
          display: flex;
          position: relative;
          margin-left: 15px;
          li {
            margin-top: 20px;
            width: 76px;
            height: 40px;
            border: 1px solid rgba(62, 147, 255, 0.8);
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.23) 0%, rgba(19, 82, 162, 0.6) 100%);
            opacity: 1;
            border-radius: 4px;
            margin-right: 17px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
      .player_SE {
        display: flex;
        .chooseTime {
          display: flex;
          align-items: center;
          margin-right: 20px;
          label {
            font-size: 20px;
          }
          .chooseTimeBg {
            width: 300px;
            height: 50px;
            background: rgba(89, 91, 95, 0.56);
            opacity: 1;
            border-radius: 6px;
            input {
              width: 100%;
              height: 100%;
              font-size: 24px;
              padding-left: 10px;
            }
          }
        }
        .back_confirm {
          font-size: 26px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
      .player_live_back {
        margin-right: 60px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .icon_live_back {
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-right: 10px;
          margin-top: 8px;
          background-image: url('./img/icon_replay_default.png');
          background-size: 100% 100%;
        }
        span {
          font-size: 28px;
        }
      }
      .player_speed {
        display: flex;
        align-items: center;
        margin-right: 50px;
        label {
          font-size: 26px;
        }
      }
    }

    .drag-point {
      position: absolute;
      left: 0px;
      top: -5px;
      width: 20px;
      height: 20px;
      border-radius: 10px;
    }
    .recoder-bar {
      position: relative;
      height: 10px;
      background: #666;
    }
    .recoders {
      position: absolute;
      height: 5px;
      background: #fff;
      border: 1px solid #ccc;
    }
    .hour-item {
      flex: 1;
      text-align: center;
      background: #000;
      color: #fff;
      border-right: 1px solid #000;
    }
  }
}
</style>
<style type="text/css" lang="scss">
.hour-bar {
  display: flex;
  width: 1545px;
  position: absolute;
  bottom: -10px;
  left: -95%;
}
.nvr-player {
  .chooseTimeBg {
    .el-date-editor {
      width: 100%;
      height: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      .el-input__inner {
        background: transparent;
        border: 0;
        font-size: 24px;
        color: #fff;
      }
      .el-input__icon,
      .el-input__prefix {
        display: none;
      }
    }
  }
}
</style>
<style type="text/css" scoped>
/*用于定位海康视频时间框位置*/
.video_date_class {
  top: 45% !important;
  left: 73% !important;
}
/*不能选择项*/
.video_date_class .el-date-table td.disabled div {
  background-color: #000;
}
.video_date_class .el-date-table td span {
  border-radius: initial;
}
.video_date_class .el-picker-panel__footer .el-button {
  background: #409eff;
  color: #fff;
}
</style>
